import React, { FC } from 'react'
import styled from 'styled-components'
import { tabNavigationStyle } from '@lojinha/design-system'
import { PurchaseCard } from '../../components/purchase-card'
import { getPurchaseStatus } from '../../core/purchase-variants'
import { t } from '../../dictionary'
import { PurchaseType } from './type'

const ListCard = styled.li`
  ${tabNavigationStyle};

  &:before {
    display: none;
  }
`

interface PurchaseCardListItemProps {
  item: PurchaseType
  tabindex: number
}

export const PurchaseCardListItem: FC<PurchaseCardListItemProps> = ({
  item,
  tabindex,
}) => {
  const { cart, order, paymentStatus, deliveryStatus } = item
  const { deliverySettings, billing } = cart

  return (
    <ListCard tabIndex={tabindex}>
      <PurchaseCard
        orderId={order}
        deliverySettings={{
          date: t.date.formatDateToUTC(deliverySettings.chosenDate),
          period: {
            name: deliverySettings.chosenPeriod.name,
            timeRange: deliverySettings.chosenPeriod.timeRange,
          },
        }}
        purchaseValue={billing.total}
        variant={getPurchaseStatus(
          paymentStatus,
          deliveryStatus,
          billing.paymentMethod.type
        )}
      />
    </ListCard>
  )
}
